export default "__VITE_ASSET__CMMa6bPI__"